const AllProjects = [
  {
    id: '097',
    name: 'CHAYA',
    category: 'full-stack',
    photo:
      'https://i.ibb.co/rwcCwTc/screencapture-bookchaya-2022-04-09-22-14-37-min-1-1-1.png',
    description:
      'CHAYA is Bangladesh’s first space sharing marketplace that connects Space owners with Users looking to find and book spaces for their needs. Here users can book stays for short term living or book a venues for party, photoshoot.',
    technologies: [
      { name: 'React' },
      { name: 'Context API' },
      { name: 'Tailwind' },
      { name: 'Firebase' },
      { name: 'NodeJS' },
      { name: 'SSLCOMMERZ' },
    ],
    github: 'https://github.com/PriontoAbdullah',
    website: 'https://www.bookchaya.com/',
    status: 'featured',
  },

  {
    id: '098',
    name: 'Anushilon - Virtual Science Lab',
    category: 'full-stack',
    photo: 'https://i.ibb.co/rc8wNNF/Oze0RSF.png',
    description:
      'ANUSILON is based on the idea that lab experiments can be taught using the internet, more efficiently and less expensively. This virtual lab available with no access to physical labs or where equipment is being scarce or costly.',
    technologies: [
      { name: 'React' },
      { name: 'Redux' },
      { name: 'Tailwind' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Mongoose' },
      { name: 'oAuth2' },
    ],
    github: 'https://github.com/PriontoAbdullah/Anushilon-Virtual-Science-Lab',
    website: 'https://anushilon-bd.web.app/',
    status: 'featured',
  },

  {
    id: '099',
    name: 'Smart Dhopa',
    category: 'full-stack',
    photo: 'https://i.ibb.co/mFgL7Sz/HuD93ZT.png',
    description:
      'This is an Online Laundry Platform web Application for E-commerce business and Manage order and Authentication with firebase. User can buy listed services by logging into it with shopping cart functionality',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'Material UI' },
      { name: 'Reactstrap' },
    ],
    github: 'https://github.com/PriontoAbdullah/Smart-Dhopa-React-App',
    website: 'https://smart-dhopa-online-laundry-app.web.app/',
    status: 'featured',
  },

  {
    id: '100',
    name: "Doctor's Portal",
    category: 'full-stack',
    photo: 'https://i.ibb.co/RcwXfTm/kecWOs1.png',
    description:
      'A Single page web app where people can pick the date time and set an appointment. A doctor can review his appointments, manage appointment and prescribe medicine to a Patient from his dashboard.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'Stripe' },
      { name: 'ReactBootstrap' },
    ],
    github: 'https://github.com/PriontoAbdullah/Online-Doctors-Portal',
    website: 'https://online-doctors-portal.web.app/',
    status: 'featured',
  },

  {
    id: '101',
    name: 'Red Onion',
    category: 'front-end',
    photo: 'https://i.ibb.co/3k1Kr5c/O4UbAvb.png',
    description:
      'An awesome food delivery restaurant web app. User can order their desired food through this app. A complete shopping cart functionality implemented User needs to login to the website by registering with manual email.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'React-Hooks-Form' },
    ],
    github:
      'https://github.com/PriontoAbdullah/Red-Onion-Online-Food-Delivery-App',
    website: 'https://red-onion-online-food-946d6.web.app/',
    status: 'featured',
  },

  {
    id: '102',
    name: 'Resume Builder',
    category: 'front-end',
    photo: 'https://i.ibb.co/bX0zCcy/DEb5T7c.png',
    description:
      'An awesome Resume Builder web app. User can register any social service by logging into it. User can log in with gmail are registering with a manual email. User can Creating a Professional Resume and Print it.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Context-api' },
      { name: 'Bootstrap' },
      { name: 'Scss' },
      { name: 'React-Router' },
    ],
    github: 'https://github.com/PriontoAbdullah/Resume-Builder-Web-App',
    website: 'https://resume-builder-bd.web.app/',
    status: 'featured',
  },

  {
    id: '103',
    name: 'Weeding Photography',
    category: 'front-end',
    photo: 'https://i.ibb.co/9sf0vk7/hvm0PdQ.jpg',
    description:
      'A full-stack single-page wedding photography service provider web app. Users can book services, monitor their book list and send messages. Admin can add services, update and delete services.',
    technologies: [
      { name: 'React' },
      { name: 'Firebase' },
      { name: 'Tailwind' },
      { name: 'Node' },
      { name: 'Express' },
      { name: 'MongoDB' },
    ],
    github: 'https://github.com/PriontoAbdullah/Wedding-Photography-Service',
    website: 'https://wedding-photography-bd.web.app/',
    status: 'featured',
  },

  {
    id: '104',
    name: 'E-Pharmacy',
    category: 'full-stack',
    photo:
      'https://i.ibb.co/yXKpycc/screencapture-e-pharmacy-bd-web-app-2022-04-09-22-18-05-1-1-1.png',
    description:
      'E-Pharmacy is a business model that deals with the preparation and sale of drugs and non-prescription medicine as in traditional pharmacies. Pharmacies take orders online and send the medicine to their destination.',
    technologies: [
      { name: 'React' },
      { name: 'Redux' },
      { name: 'NodeJS' },
      { name: 'ExpressJS' },
      { name: 'MongoDB' },
      { name: 'Tailwind' },
    ],
    github: 'https://github.com/PriontoAbdullah/E-Pharmacy',
    website: 'https://e-pharmacy-bd.web.app/',
    status: 'featured',
  },

  {
    id: '105',
    name: 'Creative Agency',
    category: 'full-stack',
    photo: 'https://i.ibb.co/9WNjD0V/HMitcZC.png',
    description:
      'This is a software service selling website. User can buy listed services by logging into it. A customer can order and review for service. Admin and User authorization implemented with dashboard.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'Heroku' },
      { name: 'ReactBootstrap' },
    ],
    github: 'https://github.com/PriontoAbdullah/creative-agency',
    website: 'https://creative-agency-71.web.app/',
    status: 'common',
  },

  {
    id: '106',
    name: 'Redux eCommerce App',
    category: 'front-end',
    photo: 'https://i.ibb.co/xL5JR6p/1VpDyPw.png',
    description:
      'This is an e-Commerce Web App. User can choose from the available products. A complete shopping cart functionality implemented. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'Redux' },
      { name: 'React' },
      { name: 'Javascript' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'Netlify' },
    ],
    github: 'https://github.com/PriontoAbdullah/Redux-eCommerce-App',
    website: 'https://redux-ecommerce-71.netlify.app/',
    status: 'common',
  },

  {
    id: '107',
    name: 'Travel Guru',
    category: 'front-end',
    photo: 'https://i.ibb.co/YQ7Vg1J/gfdg78kld.png',
    description:
      'This is a Hotel Searching App used to search hotels of selected places. Single page web application for tour booking system project with protected routes system with firebase google sign-in authentication.',
    technologies: [
      { name: 'React' },
      { name: 'Swiper' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'Firebase' },
      { name: 'Netlify' },
    ],
    github: 'https://github.com/PriontoAbdullah/Travel-Guru-App',
    website: 'https://travel-guru-71.web.app/',
    status: 'featured',
  },

  {
    id: '108',
    name: 'AKK Systems',
    category: 'front-end',
    photo:
      'https://i.ibb.co/cDRkswH/screencapture-akk-systems-web-app-2022-04-09-22-58-35-min-1.png',
    description:
      'This is a web app for a company named AKK System. AKK SYSTEMS ERP Solutions is a web based ERP solution has been developed for especially RMG(Both for Garments & Accessories) sector.',
    technologies: [
      { name: 'React' },
      { name: 'Bootstrap' },
      { name: 'Scss' },
      { name: 'Firebase' },
      { name: 'Javascript' },
      { name: 'React-Router' },
    ],
    github: 'https://github.com/PriontoAbdullah',
    website: 'https://akk-systems.web.app/',
    status: 'common',
  },

  {
    id: '109',
    name: 'Dev Blog MVC',
    category: 'full-stack',
    photo: 'https://i.ibb.co/h1mLPnq/fhOwx7w.png',
    description:
      'This is a Developer Blog Application. Here people create account, update profile, write blog article with rich text and can edit post. User can add bookmarks, Like, Dislike and Comments. User authentication and validation also implemented.',
    technologies: [
      { name: 'EJS' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Mongoose' },
      { name: 'Node' },
      { name: 'JWT' },
      { name: 'Heroku' },
      { name: 'Bootstrap' },
    ],
    github: 'https://github.com/PriontoAbdullah/Dev-Blog-MVC',
    website: 'https://dev-blog-mvc.herokuapp.com/',
    status: 'common',
  },

  {
    id: '110',
    name: 'Ema-John',
    category: 'front-end',
    photo: 'https://i.ibb.co/RytrRkj/eMgzmSQ.png',
    description:
      'This is an e-Commerce Web App like Amazon. User can choose from the available products. A complete shopping cart functionality implemented. Users need to sign in with google or manual email to consume services.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Stripe' },
      { name: 'Bootstrap' },
      { name: 'Node' },
    ],
    github: 'https://github.com/PriontoAbdullah/ema-john-ecommerce-app',
    website: 'https://ema-jhon-ecommerce-app.web.app/',
    status: 'common',
  },

  {
    id: '111',
    name: 'Payra Chat App',
    category: 'full-stack',
    photo: 'https://i.ibb.co/ZhWVTGQ/Mu7dTir.png',
    description:
      'This is a realtime chatting application. Admin can added users. User authenticate with jwt token. A user can search a user by email or phone number and start a conversation. Also they can share multiple images in their conversation.',
    technologies: [
      { name: 'Socket.io' },
      { name: 'EJS' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Mongoose' },
      { name: 'Node' },
      { name: 'JWT' },
      { name: 'Heroku' },
    ],
    github: 'https://github.com/PriontoAbdullah/Payra-Chat-App',
    website: 'https://payra-chat-app.herokuapp.com/',
    status: 'common',
  },

  {
    id: '112',
    name: 'Real Homes',
    category: 'front-end',
    photo: 'https://i.ibb.co/x6xpdkH/real-homes.png',
    description:
      'An awesome Real State Homes Finder web app. It is a buy-sell flats web app where users can search and filter with different parameters. It is built with Next.js and Rapid API.',
    technologies: [
      { name: 'NestJS' },
      { name: 'ReactJS' },
      { name: 'Rapid API' },
      { name: 'Chackra UI' },
      { name: 'Axios' },
      { name: 'Framer Motion' },
    ],
    github: 'https://github.com/PriontoAbdullah/Real-Homes-Next.js',
    website: 'https://real-homes.vercel.app/',
    status: 'common',
  },

  {
    id: '113',
    name: 'Volunteer Network',
    category: 'full-stack',
    photo: 'https://i.ibb.co/bm19f6s/NkWVWow.png',
    description:
      'This is a Social Working Platform. Single page web application with the dashboard. User can register any social service by logging into it. People can choose volunteer work for a specific date and delete them if they want.',
    technologies: [
      { name: 'React' },
      { name: 'Express' },
      { name: 'MongoDB' },
      { name: 'Firebase' },
      { name: 'Node' },
      { name: 'Heroku' },
      { name: 'ReactBootstrap' },
    ],
    github: 'https://github.com/PriontoAbdullah/Volunteer-Network',
    website: 'https://volunteer-network-71.web.app/',
    status: 'common',
  },

  {
    id: '114',
    name: 'E-Learning',
    category: 'front-end',
    photo: 'https://i.ibb.co/KXKFCbv/dgfdgsd566.png',
    description:
      'This is a frontend course selling website. User can choose courses from different courses and add this to the shopping cart. Then the user can confirm the selected courses. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'React' },
      { name: 'Javascript' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'Netlify' },
    ],
    github: 'https://github.com/PriontoAbdullah/e-learning-online-courses',
    website: 'https://e-learning-online-courses.netlify.app/',
    status: 'common',
  },

  {
    id: '115',
    name: 'Team Builder',
    category: 'front-end',
    photo: 'https://i.ibb.co/wwfFWC8/GWFHiNi.png',
    description:
      'This is a Team Builder app. Using random user API to load some people data. User can add some member to your team. Also user can review the selected member and can accept or remove.',
    technologies: [
      { name: 'React' },
      { name: 'Javascript' },
      { name: 'Bootstrap' },
      { name: 'React-Router' },
      { name: 'Netlify' },
    ],
    github: 'https://github.com/PriontoAbdullah/Employee-Management-React-App',
    website: 'https://employee-management-prionto.netlify.app/',
    status: 'common',
  },

  {
    id: '116',
    name: 'Smart Poll App',
    category: 'front-end',
    photo: 'https://i.ibb.co/vJB6z8p/c0Q3VEz.png',
    description:
      'Simple poll application built using modern technologies. User can create a poll with StrawPoll. Ask a question, choose answers and share the link. Poll maker with unlimited votes. User can see the poll statistics.',
    technologies: [
      { name: 'React' },
      { name: 'ReactStrap' },
      { name: 'Javascript' },
      { name: 'Css3' },
    ],
    github: 'https://github.com/PriontoAbdullah/Smart-Poll-React-App',
    website: 'https://smart-poll-app.netlify.app/',
    status: 'common',
  },

  {
    id: '117',
    name: 'Todo List App',
    category: 'front-end',
    photo: 'https://i.ibb.co/RBVmsd0/bT2mY7b.png',
    description:
      ' Smart todo List built using modern technologies. User can create a List. It comes with a clean interface that is user-friendly. User can add and check off tasks, add a due date or even reminders.',
    technologies: [
      { name: 'React' },
      { name: 'Bootstrap' },
      { name: 'Javascript' },
      { name: 'Css3' },
    ],
    github: 'https://github.com/PriontoAbdullah/Todo-List-react-app',
    website: 'https://todo-list-prionto.netlify.app/',
    status: 'common',
  },

  {
    id: '118',
    name: 'E-School',
    category: 'landing-page',
    photo: 'https://i.ibb.co/4V3g77G/Rm7kgkt.png',
    description:
      'This is an Online Educational Platform website. User can choose courses from different courses. Made with HTML, CSS, Bootstrap. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'Bootstrap' },
      { name: 'Figma' },
      { name: 'html5' },
      { name: 'css3' },
    ],
    github: 'https://github.com/PriontoAbdullah/e-School-Online-Education',
    website: 'https://priontoabdullah.github.io/e-School-Online-Education/',
    status: 'common',
  },

  {
    id: '119',
    name: 'Hot Gadget',
    category: 'landing-page',
    photo: 'https://i.ibb.co/dLSqq48/EjwHirg.png',
    description:
      'An awesome e-commerce website. This is a static website made with responsive layouts with HTML, CSS, Bootstrap and JavaScript. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'Javascript' },
      { name: 'Vanilla.js' },
      { name: 'Bootstrap4' },
      { name: 'Css3' },
      { name: 'Html5' },
    ],
    github: 'https://github.com/PriontoAbdullah/hot-gadget-ecommerce',
    website: 'https://priontoabdullah.github.io/hot-gadget-ecommerce/',
    status: 'common',
  },

  {
    id: '120',
    name: 'Panda e-commerce',
    category: 'landing-page',
    photo: 'https://i.ibb.co/YTNTys7/xa0aRZk.png',
    description:
      'An awesome e-commerce website. This is a static website made with HTML, CSS, Bootstrap and JavaScript. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'Javascript' },
      { name: 'Vanilla.js' },
      { name: 'Bootstrap4' },
      { name: 'Css3' },
      { name: 'Html5' },
    ],
    github: 'https://github.com/PriontoAbdullah/panda-ecommerce',
    website: 'https://priontoabdullah.github.io/panda-ecommerce/',
    status: 'common',
  },

  {
    id: '121',
    name: 'Portfolio Website',
    category: 'landing-page',
    photo: 'https://i.ibb.co/dDy6SFF/heMU2H8.png',
    description:
      'This is an amazing Personal Portfolio website. This is a static website made with HTML, CSS, Bootstrap and JavaScript. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'JQuery' },
      { name: 'Owl-carousel' },
      { name: 'Isotope-layout' },
      { name: 'Magnific-popup' },
      { name: 'Bootstrap4' },
      { name: 'Html5' },
    ],
    github: 'https://github.com/PriontoAbdullah/Portfolio-website-for-Client',
    website:
      'https://priontoabdullah.github.io/Portfolio-website-for-Client/index.html',
    status: 'common',
  },

  {
    id: '122',
    name: 'Omni Food',
    category: 'landing-page',
    photo: 'https://i.ibb.co/NFdkCr7/kUs5gwx.png',
    description:
      'This is a restaurant website.. This is a static website made with HTML, CSS, Bootstrap. Different animation is implemented to make this website interactive.',
    technologies: [{ name: 'Bootstrap4' }, { name: 'Html5' }, { name: 'Css3' }],
    github: 'https://github.com/PriontoAbdullah/my-first-website',
    website: 'https://priontoabdullah.github.io/my-first-website/',
    status: 'common',
  },

  {
    id: '123',
    name: 'Women Service',
    category: 'landing-page',
    photo: 'https://i.ibb.co/6DQ2ZrQ/QiG3F9j.png',
    description:
      'This is a simple Women Service website. This is a static website made with HTML, CSS, Bootstrap. Different animation is implemented to make this website interactive.',
    technologies: [{ name: 'Bootstrap4' }, { name: 'Css3' }, { name: 'Html5' }],
    github: 'https://github.com/PriontoAbdullah/Women-Service-Website',
    website: 'https://priontoabdullah.github.io/Women-Service-Website/',
    status: 'common',
  },

  {
    id: '124',
    name: 'Hard Rock API',
    category: 'landing-page',
    photo: 'https://i.ibb.co/b6SW60v/sTScKfh.png',
    description:
      'This is a lyrics search app used lyrics.ovh API to load song data. One can search a song by song name and select one from the search result and can hear the demo and can see album photo.',
    technologies: [
      { name: 'Javascript' },
      { name: 'api-integration' },
      { name: 'css3' },
    ],
    github: 'https://github.com/PriontoAbdullah/hard-rock-lyrics-finder-api',
    website:
      'https://priontoabdullah.github.io/hard-rock-lyrics-finder-api/index.html',
    status: 'common',
  },

  {
    id: '125',
    name: 'My Portfolio 2',
    category: 'landing-page',
    photo: 'https://i.ibb.co/KVVXbWJ/JhrbEcR.png',
    description:
      'This is my previous Portfolio website. This is a static website made with HTML, CSS, Bootstrap. Different animation is implemented to make this website interactive.',
    technologies: [{ name: 'Bootstrap4' }, { name: 'Html5' }, { name: 'Css3' }],
    github: 'https://github.com/PriontoAbdullah/My-Web-portfolio-1',
    website: 'https://priontoabdullah.github.io/My-Web-portfolio-1/',
    status: 'common',
  },

  {
    id: '126',
    name: 'My Portfolio 1',
    category: 'landing-page',
    photo: 'https://i.ibb.co/8X8s4L8/jHu0hxI.png',
    description:
      'This is my previous Portfolio website. This is a static website made with HTML, CSS, Bootstrap. Different animation is implemented to make this website interactive.',
    technologies: [{ name: 'Bootstrap4' }, { name: 'Html5' }, { name: 'Css3' }],
    github: 'https://github.com/PriontoAbdullah/portfolio-1',
    website: 'https://priontoabdullah.github.io/portfolio-1/',
    status: 'common',
  },

  {
    id: '127',
    name: 'Shopping Cart',
    category: 'others',
    photo: 'https://i.ibb.co/vZjRYZh/vMhc9Mg.png',
    description:
      'This is a simple shopping cart page. This is a static website made with HTML, CSS, Bootstrap and JavaScript. Different animation is implemented to make this website interactive.',
    technologies: [
      { name: 'Javascript' },
      { name: 'Bootstrap4' },
      { name: 'Css3' },
      { name: 'Html5' },
    ],
    github: 'https://github.com/PriontoAbdullah/shopping-cart-js',
    website: 'https://priontoabdullah.github.io/shopping-cart-js/index.html',
    status: 'common',
  },

  {
    id: '128',
    name: 'Weather App',
    category: 'others',
    photo: 'https://i.ibb.co/j62NXwG/0Da2HkN.png',
    description:
      'This is a Weather app. This can show weather update of current location extracting current location. One can search for a city name and get weather update of this specific location.',
    technologies: [
      { name: 'Javascript' },
      { name: 'api-integration' },
      { name: 'open-weather-api' },
      { name: 'html5' },
      { name: 'css3' },
    ],
    github: 'https://github.com/PriontoAbdullah/Weather-App-JS-API',
    website: 'https://priontoabdullah.github.io/Weather-App-JS-API/',
    status: 'common',
  },

  {
    id: '129',
    name: 'Pioneer Bank',
    category: 'landing-page',
    photo: 'https://i.ibb.co/7vynWCt/6ysmchG.png',
    description:
      'This is a simple banking website. Where user can deposit money or withdraw it. This is a static website made with HTML, CSS, Bootstrap and JavaScript.',
    technologies: [
      { name: 'Javascript' },
      { name: 'Vanilla.js' },
      { name: 'Bootstrap4' },
      { name: 'Css3' },
      { name: 'Html5' },
    ],
    github: 'https://github.com/PriontoAbdullah/pioneer-bank-dynamic-site',
    website:
      'https://priontoabdullah.github.io/pioneer-bank-dynamic-site/index.html',
    status: 'common',
  },

  {
    id: '130',
    name: 'Issue Tracker',
    category: 'others',
    photo: 'https://i.ibb.co/F3Bnk2p/uxWiJqv.png',
    description:
      'This is a simple vanilla JavaScript project. User can add their issue. After adding a list of issue will be shown. User can review the list and can delete one and can mark as closed.',
    technologies: [
      { name: 'Javascript' },
      { name: 'Bootstrap4' },
      { name: 'Css3' },
      { name: 'HTML5' },
    ],
    github: 'https://github.com/PriontoAbdullah/issue-tracker-js-app',
    website: 'https://priontoabdullah.github.io/issue-tracker-js-app/',
    status: 'common',
  },

  {
    id: '131',
    name: 'Digital Calculator',
    category: 'others',
    photo: 'https://i.ibb.co/cknvJQz/zL4qCM0.png',
    description:
      'This is a digital calculator app that can perform almost all kind of mathematical operations that a regular calculator can perform. This is made with pure JavaScript and HTML, CSS',
    technologies: [
      { name: 'Javascript' },
      { name: 'Css3' },
      { name: 'Html5' },
      { name: 'Vanilla.js' },
    ],
    github: 'https://github.com/PriontoAbdullah/Simple-Calculator-Vanilla-JS',
    website: 'https://priontoabdullah.github.io/Simple-Calculator-Vanilla-JS/',
    status: 'common',
  },

  {
    id: '132',
    name: 'Pin Matcher Vault OTP',
    category: 'others',
    photo: 'https://i.ibb.co/b21MdMn/mS6abmU.png',
    description:
      'This is an simple OTP pin generator system that can perform almost all kind of mathematical operations that a regular vault can perform. This is made with pure JavaScript and HTML, CSS',
    technologies: [{ name: 'Javascript' }, { name: 'Css3' }, { name: 'Html5' }],
    github: 'https://github.com/PriontoAbdullah/Pin-matcher-vault-OTP',
    website: 'https://priontoabdullah.github.io/Pin-matcher-vault-OTP/',
    status: 'common',
  },

  {
    id: '133',
    name: 'Tic Tac Toe Game',
    category: 'others',
    photo: 'https://i.ibb.co/pbqKGqs/CIuT4D4.png',
    description:
      'The goal of the game is for players to position their marks so that they make a continuous line of three cells vertically, horizontally, or diagonally. This is made with React.js',
    technologies: [
      { name: 'React' },
      { name: 'Javascript' },
      { name: 'Css3' },
      { name: 'Netlify' },
    ],
    github: 'https://github.com/PriontoAbdullah/tic-tac-toe-react-game',
    website: 'https://tic-tac-toe-react-games.netlify.app/',
    status: 'common',
  },
];
export default AllProjects;
